let initialized = false;

/** Buffered observers can load after the page's critical resources. */
export const initPerformance = () => {
  if (initialized) return;
  initialized = true;
  const sampleRate = import.meta.env.PUBLIC_APP_ENV === "production" ? 0.1 : 1;
  if (Math.random() > sampleRate) return;
  const start = async () => {
    const { onLCP, onCLS, onINP, onFCP, onTTFB } = await import("web-vitals");
    const path = window.location.pathname;
    const route = path === "/" ? "home" : path.startsWith("/categoria/") ? "category" :
      path.startsWith("/producto/") ? "product" : path.startsWith("/busqueda") ? "search" :
      path.startsWith("/checkout") ? "checkout" : path.startsWith("/cuenta") ? "account" : "other";
    const device = matchMedia("(max-width: 767px)").matches ? "mobile" : "desktop";
    const report = ({ name, value }: { name: string; value: number }) => {
      const body = new Blob([JSON.stringify({ name, value, route, device })], { type: "application/json" });
      navigator.sendBeacon("/api/performance", body);
    };
    [onLCP, onCLS, onINP, onFCP, onTTFB].forEach(observer => observer(report));
  };
  const defer = () => {
    if ("requestIdleCallback" in window) requestIdleCallback(() => void start().catch(() => {}), { timeout: 3000 });
    else setTimeout(() => void start().catch(() => {}), 0);
  };
  if (document.readyState === "complete") defer();
  else window.addEventListener("load", defer, { once: true });
};
